<template>
  <div v-if="shouldRender" data-component="reconciliation-status">
    <i :class="iconClasses" :data-testid="iconTestId" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type {
  WorkflowOverviewGroup,
  WorkflowOverviewItem,
} from '@app/application/workflow-overview-navigation/types'

import { isWorkflowOverviewItem } from '../predicates'
import { useWorkflowProgress } from '../store/workflow-progress'
import {
  getReconIconState,
  shouldRenderReconIcon,
} from '../utils/workflow-icon-helper'

interface Props {
  item: WorkflowOverviewItem | WorkflowOverviewGroup
}

const props = defineProps<Props>()

const workflowProgressStore = useWorkflowProgress()

const workflowStatus = computed(() => {
  if (!isWorkflowOverviewItem(props.item) || !props.item.type) {
    return null
  }

  const objectType =
    props.item.type === 'account_entry' ? 'account' : props.item.type
  const objectId = props.item.id

  return workflowProgressStore.getStatusForItem(objectType, objectId)
})

const shouldRender = computed(() => {
  if (!isWorkflowOverviewItem(props.item)) {
    return false
  }

  return shouldRenderReconIcon(workflowStatus.value)
})

const iconClasses = computed(() => {
  if (workflowStatus.value) {
    const iconState = getReconIconState(workflowStatus.value)
    return [iconState.iconClass, iconState.colorClass].filter(Boolean).join(' ')
  }

  return ''
})

const iconTestId = computed(() => {
  if (workflowStatus.value) {
    const iconState = getReconIconState(workflowStatus.value)
    if (iconState.iconClass.includes('i-reconciled')) {
      return 'reconciled-icon'
    }
    if (iconState.iconClass.includes('i-unreconciled')) {
      return 'unreconciled-icon'
    }
    if (iconState.iconClass.includes('i-no-reconciliation-needed')) {
      return 'no-reconciliation-needed-icon'
    }
  }

  return ''
})
</script>
